<template>
  <div class="tabs">
    <ul :class="['tabs__header', { 'is-card': card }]">
      <li
        :class="['tabs__header-item', { 'is-active': activeId === item.id }, { 'is-disabled': item.disabled }]"
        v-for="(item, index) in childrens"
        :key="index"
        @click.stop="!item.disabled && handleClick(item)"
      >
        <span>{{ item.label }}</span>
      </li>
    </ul>

    <div class="tabs__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BccTabs',
  props: {
    value: { type: [Number, String] },
    card: { type: Boolean, default: false }
  },
  data () {
    return {
      activeId: '',
      childrens: []
    }
  },
  provide () {
    return {
      BccTabs: this
    }
  },
  watch: {
    childrens (value) {
      const idMap = {}
      const error = value.every(item => {
        const { id } = item
        if (idMap[id]) {
          return false
        }
        idMap[id] = true
        return true
      })
      if (!error) throw new Error('Tab has duplicate ID')
      if (this.childrens.length) {
        let flag = false
        for (const iterator of this.childrens) {
          if (this.value === iterator.id && !iterator.disabled) {
            this.activeId = iterator.id
            flag = true
            break
          }
        }
        if (!flag) { this.activeId = this.childrens.filter(item => !item.disabled)[0].id }
      }
    },
    value (value) {
      this.activeId = value
    }
  },
  methods: {
    handleClick (item) {
      if (this.activeId !== item.id) {
        this.activeId = item.id
        this.$emit('on-change', item.id)
      }
    }
  }
}
</script>
